import { useTranslator } from "@eo-locale/react";

import { string } from "yup";

import { CommonEssayQuestion } from "@/storybook-components";
import type { ChangeEvent } from "react";

import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { setAnswer } from "@/redux/features/place-form/slice";
import type { PlacesQuestion, QuestionClass } from "@/types";

export const validate = async (
  answer: string,
  question: QuestionClass
): Promise<string[]> => {
  let schema = string();
  if (question.required) {
    schema = schema.required();
  }
  try {
    await schema.validate(answer);
    return [];
  } catch (err) {
    return err.errors;
  }
};

const EssayQuestionComponent = (props: PlacesQuestion): JSX.Element => {
  const { question } = props;
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { answers, answerErrors } = useAppSelector((state) => state.placesForm);

  const error = answerErrors[question?.id] || "";
  const essayAnswer = answers[question?.id] || "";

  const { question: title, id, required, notes } = question || {};
  const updatedTitle =
    title === "Your Comment"
      ? `${title?.toLocaleLowerCase()?.[0]?.toUpperCase()}${title
          ?.toLocaleLowerCase()
          ?.substring?.(1)}`
      : title;
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    dispatch(
      setAnswer({
        questionId: question.id,
        answer: e.target.value
      })
    );
  };

  return (
    <CommonEssayQuestion
      questionId={id}
      errorMessage={error && translate(`errors.${error}`)}
      note={notes}
      className={error.length ? "ehqQuestionError" : null}
      questionLabel={updatedTitle}
      isInvalid={error.length}
      isRequired={required}
      withErrorIcon={error.length}
      changeEventHandler={handleChange}
      answer={essayAnswer}
      spacing={0}
      questionLabelProps={{
        marginTop: 6
      }}
      answerProps={{
        backgroundColor: "white"
      }}
    />
  );
};

export default EssayQuestionComponent;
